export default __webpack_public_path__ + "static/img-a9c7e6a7e06eaa04dd7da7f19d6f6816.jpg";